"use client"

import { Fragment, useEffect, useState } from "react";

import { GrayButton, IndigoButton } from "../../Atoms/Buttons/ColorButtons";
import JobAlertBox from "@/components/Molecules/JobAlertBox";
import Link from "next/link";
import LocationSelect from "@/components/Atoms/Select/LocationSelect";
import { usePathname, useSearchParams, useRouter } from "next/navigation";
import { humanizeString, standardizeLocationName } from "@/utils/frontend/stringOps";
import SearchForm from "@/components/Atoms/FormElements/SearchForm";
import sectors from "@/json/sectors.json"
import LocationSelectGeoNames from "@/components/Atoms/Select/LocationSelectGeoNames";

const Sidebar = ({ callback, parentModule, organizationPreferences, lang, tags, parentComponent, filteredLocation, filteredLocObj }) => {



  const router = useRouter();

  // PEOPLE FILTERS

  // dropdowns open close
  const [tagsDropdownOpen, setTagsDropdownOpen] = useState(false);
  const [communicationLanguagesDropdownOpen, setCommunicationLanguagesDropdownOpen] = useState(false);
  const [languagesDropdownOpen, setLanguagesDropdownOpen] = useState(false);
  // filtered
  const [communicationLanguagesFiltered, setCommunicationLanguagesFiltered] = useState(null);
  const [tagsFiltered, setTagsFiltered] = useState(null);
  const [filtered, setFiltered] = useState(null) // to modify according to element calling it (see line above)
  // show hide selects
  const [showTagSelect, setShowTagSelect] = useState(false);
  const [showCommunicationLanguagesSelect, setShowCommunicationLanguagesSelect] = useState(false);
  const [showBooleanSelect, setShowBooleanSelect] = useState(false);

  // TASKS FILTERS
  const [taskStatusDropdownOpen, setTaskStatusDropdownOpen] = useState(false);
  const [taskDateDropdownOpen, setTaskDateDropdownOpen] = useState(false);
  const [presetFilterQuery, setPresetFilterQuery] = useState(null)
  const [filterQuery, setFilterQuery] = useState(null)

  const [locationQuery, setLocationQuery] = useState(null)
  const [presetLocationQuery, setPresetLocationQuery] = useState(null)

  const [filteredTagId, setFilteredTagId] = useState(null)
  const [filteredTagParentTagId, setFilteredTagParentTagId] = useState(null)

  const searchParams = useSearchParams()
  const [sectorIndustryId, setSectorIndustryId] = useState(Number(searchParams.get('sectorId')) || null)

  // const pathname = usePathname()

  console.log(searchParams.get('sectorId'))
  const query = searchParams.get('query') || ''
  const filter = searchParams.get('filter') || ''
  // const search = searchParams.get('url')
  const [url, setUrl] = useState({})



 





  const toggleDropdown = (filterAttribute) => {
    console.log(filterAttribute);
    if (filterAttribute === "tags") {
      setTagsDropdownOpen(!tagsDropdownOpen);
    }
    if (filterAttribute === "languages") {
      setLanguagesDropdownOpen(!languagesDropdownOpen);
    }
    if (filterAttribute === "communication_languages") {
      setCommunicationLanguagesDropdownOpen(!communicationLanguagesDropdownOpen);
    }
    if (filterAttribute === "taskStatus") {
      setTaskStatusDropdownOpen(!taskStatusDropdownOpen);
    }
    if (filterAttribute === "taskDate") {
      setTaskDateDropdownOpen(!taskDateDropdownOpen);
    }
  };

  const closeDropdown = () => {
    setTagsDropdownOpen(false);
  };

  useEffect(() => {
    // Attach a click event listener to the document
    //  document.addEventListener("click", closeDropdown);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", closeDropdown);
    };
  }, []);

  const handleDropdownClick = (e) => {
    // Prevent the click on the dropdown itself from triggering the closeDropdown
    e.stopPropagation();
  };

  const handleToggleClick = (event, filterAttribute) => {
    event.stopPropagation();
    toggleDropdown(filterAttribute);
  };

  const handlePresetFilterClick = (event, presetFilterQuery ) => {
    event.stopPropagation();
    setPresetFilterQuery(presetFilterQuery)
    callback({ action: "filterApplied", presetFilterQuery: presetFilterQuery });
  }


  const handleChildCallback = (cb) => {
    // FilterSidebarDropdown
    console.log("CALLBACK@FILTERSIDEBAR", cb);

    if (cb.filtersApplied) {
      setFilterQuery(cb.filtersApplied)
    }

    if (cb.action === 'presetFilterApplied'){ 
      callback({ action: "filterApplied", presetFilterQuery: cb.presetFilterQuery });
    }

    if (cb.action === "filterParameter") {
      if (cb.attribute === 'tags') {
        setTagsFiltered({ ...tagsFiltered, parameter: cb.parameter });
        if (cb.parameter === "IS_EMPTY") {
          setShowBooleanSelect(true);
          setShowTagSelect(false);
        } else {
          setShowTagSelect(true);
          setShowBooleanSelect(false);
        }
      }
      else if (cb.attribute === 'communication_languages'){
        setCommunicationLanguagesFiltered({ ...communicationLanguagesFiltered, parameter: cb.parameter });
        setShowCommunicationLanguagesSelect(true)
      }
    }

    // FilterMultiSelect
    if (cb.action === "filterProperty") {
      console.log(cb);
      if (cb.attribute === 'tags') {
        setTagsFiltered({
        ...tagsFiltered,
        attribute: cb.attribute,
        properties: cb.properties,
        })
      }
      else if (cb.attribute === 'communication_languages') {
        setCommunicationLanguagesFiltered({
          ...communicationLanguagesFiltered,
          attribute: cb.attribute,
          properties: cb.properties,
          })
      }
    }

    if (cb.action === "filterBoolean") {
      setTagsFiltered({
        ...tagsFiltered,
        attribute: cb.attribute,
        booleanValue: cb.value,
      });
    }
    // console.log("FILTERED", filtered);
    // callback({action: 'filter', filterQuery: filtered})
  };


  const mergedFilters = () => {
    return {
      tagsFiltered: tagsFiltered,
      communicationLanguagesFiltered: communicationLanguagesFiltered
    }
  }


  const buildHref = (updates) => {
  const params = new URLSearchParams(searchParams.toString());
  Object.entries(updates).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      params.delete(key);
    } else {
      params.set(key, value);
    }
  });
  const qs = params.toString();
  return qs ? `?${qs}` : '?';
};

  return (
    // can get rid of div and leave aside
    <div> 
      <aside
        id="sidebar"
        className="overflow-y-scroll pb-14 px-2 fixed top-20 z-30 w-72 h-[80vh] transition-transform -translate-x-full sm:translate-x-0 dark:border-gray-800"
        // bg-white dark:bg-gray-900
        aria-label="Sidebar"
      >



{/* ---- JOBS ---- */}
{parentComponent.includes('JOBS') && 
  <div className="mb-2">
    {/* <LocationSelect zoomLevel={'COUNTRIES'} placeholder={lang==='fr' ?  humanizeString(filteredLocation) || 'Sélectionnez la Localisation..' : humanizeString(filteredLocation) || 'Select Location..'} onChange={(x)=>{

                router.push(`/jobs/in/${standardizeLocationName(x.value.split(',')[0])}?${window.location.search}`);
                router.push(`/jobs/in/${standardizeLocationName(x.value.split(',')[0])}${searchParams}`);
                used for cities and states (provinces)
                router.push(`../../../jobs/in/${standardizeLocationName(x.value.split(',')[0])}${window.location.search}`) 
                used for countries
                router.push(`../../../jobs/in/${x.value}${window.location.search}`)       
  }}/> */}

  {/* {console.log("FILTEREDLOCOBJ", filteredLocObj)} */}
      
  <LocationSelectGeoNames
    name="job_location"
    id="job_location"
    placeholder={'Start typing in a city name...'}
    // placeholder="Start typing in your city name..."
    // placeholder={filteredLocObj ? {label: `${filteredLocObj.city}, ${filteredLocObj.region}, ${filteredLocObj.country}`, value: filteredLocObj.city} : 'Start typing in your city name...'}
    // value={
    //   newUserData.user_location
    //     ? {
    //         value: newUserData.user_location.value,
    //         label: newUserData.user_location.label
    //       }
    //     : null
    // }
    // value= { newUserData.user_location || null}
    value={filteredLocObj ? {label: Object.keys(filteredLocObj).map(key=>{return humanizeString(filteredLocObj[key])}).join(', '), value: filteredLocObj.city} : null}
    onChange={(selection) => {
      if (selection?.city) {
        const params = new URLSearchParams(window.location.search);
        params.set('lat', selection.lat);
        params.set('lng', selection.lng);
        params.set('city', selection.city);
        params.set('region', selection.admin);
        params.set('country', selection.country);
        params.set('country', selection.country);
        router.push(`/jobs/?${params.toString()}`);
      }
    }}
    // onChange={(selection) => {
    //   console.log("SELECTION",selection)
    //   // setPresetLocationQuery(selection)
    //   // setLocationQuery(selection)
    //   if (selection?.city){
    //   router.push(`/jobs/?lat=${selection.lat}&lng=${selection.lng}&city=${selection.city}&region=${selection.admin}&country=${selection.country}${window.location.search}`)
    //   }
    //   // console.log("SELECTION", selection)
    //   // setNewUserData({
    //   //   ...newUserData,
    //   //   user_location: selection
    //   // });
    //   // setActiveFieldName("user_location");
    // }}
  />

            
  </div>
}

{/* ---- TALENTS ---- */}
{parentComponent.includes('TALENT') && 
  <div className="mb-2">
      
  <LocationSelectGeoNames
    name="talent_location"
    id="talent_location"
    placeholder={'Start typing in a city name...'}
    value={filteredLocObj ? {label: Object.keys(filteredLocObj).map(key=>{return humanizeString(filteredLocObj[key])}).join(', '), value: filteredLocObj.city} : null}
    onChange={(selection) => {
      if (selection?.city) {
        const params = new URLSearchParams(window.location.search);
        params.set('lat', selection.lat);
        params.set('lng', selection.lng);
        params.set('city', selection.city);
        params.set('region', selection.admin);
        params.set('country', selection.country);
        params.set('country', selection.country);
        router.push(`/talent/?${params.toString()}`);
      }
    }}
  />

            
  </div>
}



<Link 
          // href={parentComponent === 'TALENT' ? 'talent' : 'jobs'} 
          href={`/${parentComponent?.toLowerCase()}`}
          
            // href={buildHref({ sectorId: sectorIndustryId === sector.id ? null : sector.id })}
          // href={router.push('/?')}
          onClick={()=>{setSectorIndustryId(null)}}>
            <div className={`${sectorIndustryId === null && 'border-l-8 border-slate-600 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-base duration-200 rounded-lg font-ubuntu`}>
            {lang === 'fr' ? "Tous les Secteurs" : 'All Sectors'} 
            </div>
          </Link>



{/* PROGRAMMATIC */}


{sectors.map(sector => 
  <div key={sector.id}>

    
              <Link 
          // href={sectorIndustryId === 1 ? `?sectorId=${null}` : `?sectorId=${sector.id}${filter && `&filter=${filter}`}${query && `&query=${query}`}`}
           href={buildHref({ sectorId: sectorIndustryId === sector.id ? null : sector.id })}

          onClick={()=>{
            setSectorIndustryId(sectorIndustryId === sector.id ? null : sector.id); // if current sector selected is already 1, set to null, else, set to 1
            setFilteredTagId(null)}}
            >
            <div className={`${sectorIndustryId === sector.id && 'border-l-8 border-teal-400 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-base duration-200 rounded-lg`}>
            {/* {lang === 'fr' ? <h2 className="font-ubuntu normal-case">{sector.label_fr}</h2> : <h2 className="font-ubuntu normal-case">Information Technology</h2>}  */}
            <h2 className="font-ubuntu normal-case">{sector[`label_${lang}`]}</h2>
            </div>
          </Link>

          <ul className={`${sectorIndustryId === sector.id ? 'visible' : 'hidden'} ml-4`}>
          <Link 
            href={parentComponent === 'TALENT' ? 'talent?sectorId=1' : 'jobs?sectorId=1'} 
            onClick={()=>{setFilteredTagId(null)}}>
      <li className={`${!filteredTagId && 'border-l-8 border-teal-500 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-base duration-200 rounded-lg font-ubuntu`}>
      {parentComponent === 'TALENT' && lang === 'fr' ? 'Tous les Talents' : parentComponent === 'TALENT' && lang === 'en' ? 'All Talent' : parentComponent === 'JOBS' && lang === 'fr' ? 'Tous les Emplois' : parentComponent === 'JOBS' && lang === 'en' ? 'All Jobs' : 'All / Tous'} 

      </li>
  </Link>
  {tags && tags.filter(tag=>tag.tag_level === 1 && tag.tag_sector_industry.id === sector.id).sort((a, b) => {
            // If both positions are null, keep their original order
            if (a.tag_sidebar_position === null && b.tag_sidebar_position === null) return 0;
            
            // Place tags with null position at the top
            if (a.tag_sidebar_position === null) return -1;
            if (b.tag_sidebar_position === null) return 1;
            
            // Otherwise, sort by position in ascending order
            return a.tag_sidebar_position - b.tag_sidebar_position;
          }).map(tag => {
            return (
              <Fragment key={tag.id}>
            <Link key={tag.id} href={`?tagId=${tag.id}`} onClick={()=>{setFilteredTagId(tag.id); setFilteredTagParentTagId(null)}}>
              <li className={`${filteredTagId === tag.id && 'border-l-8 border-teal-500 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-base duration-200 rounded-lg`}>
              {/* <div className="flex justify-between items-center">
              <span>{tag[`tag_name_${lang}`]}</span><span><i className={`fa-solid ${filteredTagId === tag.id ? 'fa-angle-up' : 'fa-angle-down'}`}></i></span>
                </div> */}
              <h3 className="font-ubuntu normal-case">{tag[`tag_name_${lang}`]}</h3>
              </li>
            </Link>
            {tags.map(childTag=>{
              if (childTag.parent_tag_id === tag.id) {
                return (
                  <div key={childTag.id} className={filteredTagId === tag.id || filteredTagParentTagId === tag.id ? `visible ml-4` : 'hidden'}>
                  <Link key={childTag.id} href={`?tagId=${childTag.id}`} onClick={()=>{setFilteredTagId(childTag.id); setFilteredTagParentTagId(tag.id)}}>
                  <li className={`${filteredTagId === childTag.id && 'border-l-8 border-teal-500 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-base duration-200 rounded-lg`}>
                  <h4 className="font-ubuntu normal-case">{childTag[`tag_name_${lang}`]}</h4>
                  </li>
                </Link>
                </div>
                )
              }
            })}
            </Fragment>
            )
            }
    )}
            </ul>

  </div>
)}

















{/* CONSTRUCTION */}
        {/* <Link 
      href={sectorIndustryId === 5 ? `?sectorId=${null}` : `?sectorId=${5}`}
      onClick={()=>{setSectorIndustryId(sectorIndustryId === 5 ? null : 5);setFilteredTagId(null)}}>
        <div className={`${sectorIndustryId === 5 && 'border-l-8 border-fuchsia-600 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg`}>
        {lang === 'fr' ? <h2 className="font-ubuntu normal-case">Construction</h2> : <h2 className="font-ubuntu normal-case">Construction</h2> } 
        </div>
      </Link>

      <ul className={`${sectorIndustryId === 5 ? 'visible' : 'hidden'} ml-4`}>
            <Link 
            href={`?sectorId=${5}`}
            // href={parentComponent === 'TALENT' ? 'talent?sectorId=2' : 'jobs'} 
            onClick={()=>{setFilteredTagId(null)}}>
        <li className={`${!filteredTagId && 'border-l-8 border-fuchsia-600 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg`}>
        {parentComponent === 'TALENT' && lang === 'fr' ? 'Tous les Talents' : parentComponent === 'TALENT' && lang === 'en' ? 'All Talent' : parentComponent === 'JOBS' && lang === 'fr' ? 'Tous les Emplois' : parentComponent === 'JOBS' && lang === 'en' ? 'All Jobs' : 'All / Tous'} 

        </li>
    </Link>
    {tags && tags.filter(tag=>tag.tag_level === 1 && tag.tag_sector_industry.id === 5 )
    .sort((a, b) => {
      // If both positions are null, keep their original order
      if (a.tag_sidebar_position === null && b.tag_sidebar_position === null) return 0;
      
      // Place tags with null position at the top
      if (a.tag_sidebar_position === null) return -1;
      if (b.tag_sidebar_position === null) return 1;
      
      // Otherwise, sort by position in ascending order
      return a.tag_sidebar_position - b.tag_sidebar_position;
    })
    .map(tag => {
      return(
        <>
      <Link key={tag.id} href={`?tagId=${tag.id}`} onClick={()=>{setFilteredTagId(tag.id)}}>
        <li className={`${filteredTagId === tag.id && 'border-l-8 border-fuchsia-600 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg`}>
        <h3 className="font-ubuntu normal-case">{tag[`tag_name_${lang}`]}</h3>
        </li>
    </Link>
    {tags.map(childTag=>{
          if (childTag.parent_tag_id === tag.id) {
            return (
              <div className={filteredTagId === tag.id || filteredTagParentTagId === tag.id ? `visible ml-4` : 'hidden'}>
              <Link key={childTag.id} href={`?tagId=${childTag.id}`} onClick={()=>{setFilteredTagId(childTag.id); setFilteredTagParentTagId(tag.id)}}>
              <li className={`${filteredTagId === childTag.id && 'border-l-8 border-purple-600 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg`}>
              <h4 className="font-ubuntu normal-case">{childTag[`tag_name_${lang}`]}</h4>
              </li>
            </Link>
            </div>
            )
          }
        })}
    </>
    )
    }
      )}
        </ul> */}





{/* GENERAL LABOUR */}
       {/* { parentComponent ==='JOBS' && <> 
       <Link 
      href={sectorIndustryId === 99 ? `?sectorId=${null}` : `?sectorId=${99}${filter && `&filter=${filter}`}${query && `&query=${query}`}`}
      onClick={()=>{setSectorIndustryId(sectorIndustryId === 99 ? null : 99);setFilteredTagId(null)}}>
        <div className={`${sectorIndustryId === 99 && 'border-l-8 border-fuchsia-600 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg`}>
        {lang === 'fr' ? <h2 className="font-ubuntu normal-case">Travail Général</h2> : <h2 className="font-ubuntu normal-case">General Labour</h2> } 
        </div>
      </Link>

      <ul className={`${sectorIndustryId === 99 ? 'visible' : 'hidden'} ml-4`}>
            <Link 
            href={`?sectorId=${99}`}
            // href={parentComponent === 'TALENT' ? 'talent?sectorId=2' : 'jobs'} 
            onClick={()=>{setFilteredTagId(null)}}>
        <li className={`${!filteredTagId && 'border-l-8 border-fuchsia-600 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg font-ubuntu`}>
        {parentComponent === 'TALENT' && lang === 'fr' ? 'Tous les Talents' : parentComponent === 'TALENT' && lang === 'en' ? 'All Talent' : parentComponent === 'JOBS' && lang === 'fr' ? 'Tous les Emplois' : parentComponent === 'JOBS' && lang === 'en' ? 'All Jobs' : 'All / Tous'} 

        </li>
    </Link>
    {tags && tags.filter(tag=>tag.tag_level === 1 && tag.tag_sector_industry.id === 99 )
    .sort((a, b) => {
      // If both positions are null, keep their original order
      if (a.tag_sidebar_position === null && b.tag_sidebar_position === null) return 0;
      
      // Place tags with null position at the top
      if (a.tag_sidebar_position === null) return -1;
      if (b.tag_sidebar_position === null) return 1;
      
      // Otherwise, sort by position in ascending order
      return a.tag_sidebar_position - b.tag_sidebar_position;
    })
    .map(tag => {
      return(
        <>
      <Link key={tag.id} href={`?tagId=${tag.id}`} onClick={()=>{setFilteredTagId(tag.id)}}>
        <li className={`${filteredTagId === tag.id && 'border-l-8 border-fuchsia-600 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg`}>
        <h3 className="font-ubuntu normal-case">{tag[`tag_name_${lang}`]}</h3>
        </li>
    </Link>
    {tags.map(childTag=>{
          if (childTag.parent_tag_id === tag.id) {
            return (
              <div className={filteredTagId === tag.id || filteredTagParentTagId === tag.id ? `visible ml-4` : 'hidden'}>
              <Link key={childTag.id} href={`?tagId=${childTag.id}`} onClick={()=>{setFilteredTagId(childTag.id); setFilteredTagParentTagId(tag.id)}}>
              <li className={`${filteredTagId === childTag.id && 'border-l-8 border-purple-600 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg`}>
              <h4 className="font-ubuntu normal-case">{childTag[`tag_name_${lang}`]}</h4>
              </li>
            </Link>
            </div>
            )
          }
        })}
    </>
    )
    }
      )}
        </ul>
        </>} */}




          {/* HEALTHCARE */}
          {/* <Link 
          href={`?sectorId=${3}`}

          onClick={()=>{setSectorIndustryId(3)}}>
            <div className={`${sectorIndustryId === 3 && 'border-l-8 border-sky-400 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg`}>
            { lang === 'fr' ? "Santé" : 'Healthcare'} 
            </div>
          </Link>

          <ul className={`${sectorIndustryId === 3 ? 'visible' : 'hidden'} ml-4`}>
                <Link href={parentComponent === 'TALENT' ? 'talent?sectorId=3' : 'jobs'} onClick={()=>{setFilteredTagId(null)}}>
            <li className={`${!filteredTagId && 'border-l-8 border-sky-400 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg`}>
            {parentComponent === 'TALENT' && lang === 'fr' ? 'Tous les Talents' : parentComponent === 'TALENT' && lang === 'en' ? 'All Talent' : parentComponent === 'JOBS' && lang === 'fr' ? 'Tous les Emplois' : parentComponent === 'JOBS' && lang === 'en' ? 'All Jobs' : 'All / Tous'} 
  
            </li>
        </Link>
        {tags && tags.filter(tag=>tag.tag_level === 1 && tag.tag_sector_industry.id === 3 )
        .sort((a, b) => {
          // If both positions are null, keep their original order
          if (a.tag_sidebar_position === null && b.tag_sidebar_position === null) return 0;
          
          // Place tags with null position at the top
          if (a.tag_sidebar_position === null) return -1;
          if (b.tag_sidebar_position === null) return 1;
          
          // Otherwise, sort by position in ascending order
          return a.tag_sidebar_position - b.tag_sidebar_position;
        })
        .map(tag => 
         <Link key={tag.id} href={`?tagId=${tag.id}`} onClick={()=>{setFilteredTagId(tag.id)}}>
            <li className={`${filteredTagId === tag.id && 'border-l-8 border-sky-400 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg`}>
{tag[`tag_name_${lang}`]}
            </li>
        </Link>
          )}
            </ul> */}


            
        <div className="px-4 pb-4 overflow-y-auto ">


    
        <div>
    {/* <div class="gp-container-title social-icons-bar">
     <img src="../assets/icons/bell2.svg" className="social-icons" style={{width:"20px"}}/>
     Create a Job Alert</div> */}
    <br/>

 {/* <JobAlertBox lang={lang}/> */}
  
  </div>


        </div>

        {/* <div className="fixed bottom-6  ml-4 z-20 flex space-x-4 ml-14">
          <IndigoButton
            caption={"Apply Filter(s)"} // this applies customFilter
            onClick={() => {
              console.log("filterQuery", filterQuery)
              callback({ action: "filtersApplied", filterQuery: filterQuery }); 
            }}
            fontSize={"xs"}
          />
          <GrayButton
            caption={"Reset"}
            fontSize={"xs"}
            onClick={() => {
              callback({ action: "filterReset" });
              setFiltered(null);
              setShowTagSelect(null);
            }}
          />
        </div> */}
      </aside>


    </div>
  );
};

export default Sidebar;






































// "use client"

// import { useEffect, useState } from "react";

// import { GrayButton, IndigoButton } from "../../Atoms/Buttons/ColorButtons";
// import JobAlertBox from "@/components/Molecules/JobAlertBox";
// import Link from "next/link";


// const Sidebar = ({ callback, parentModule, organizationPreferences, lang, tags, parentComponent }) => {

//   // PEOPLE FILTERS

//   // dropdowns open close
//   const [tagsDropdownOpen, setTagsDropdownOpen] = useState(false);
//   const [communicationLanguagesDropdownOpen, setCommunicationLanguagesDropdownOpen] = useState(false);
//   const [languagesDropdownOpen, setLanguagesDropdownOpen] = useState(false);
//   // filtered
//   const [communicationLanguagesFiltered, setCommunicationLanguagesFiltered] = useState(null);
//   const [tagsFiltered, setTagsFiltered] = useState(null);
//   const [filtered, setFiltered] = useState(null) // to modify according to element calling it (see line above)
//   // show hide selects
//   const [showTagSelect, setShowTagSelect] = useState(false);
//   const [showCommunicationLanguagesSelect, setShowCommunicationLanguagesSelect] = useState(false);
//   const [showBooleanSelect, setShowBooleanSelect] = useState(false);

//   // TASKS FILTERS
//   const [taskStatusDropdownOpen, setTaskStatusDropdownOpen] = useState(false);
//   const [taskDateDropdownOpen, setTaskDateDropdownOpen] = useState(false);
//   const [presetFilterQuery, setPresetFilterQuery] = useState(null)
//   const [filterQuery, setFilterQuery] = useState(null)

//   const [filteredTagId, setFilteredTagId] = useState(null)
//   const [sectorIndustryId, setSectorIndustryId] = useState(1)






//   const toggleDropdown = (filterAttribute) => {
//     console.log(filterAttribute);
//     if (filterAttribute === "tags") {
//       setTagsDropdownOpen(!tagsDropdownOpen);
//     }
//     if (filterAttribute === "languages") {
//       setLanguagesDropdownOpen(!languagesDropdownOpen);
//     }
//     if (filterAttribute === "communication_languages") {
//       setCommunicationLanguagesDropdownOpen(!communicationLanguagesDropdownOpen);
//     }
//     if (filterAttribute === "taskStatus") {
//       setTaskStatusDropdownOpen(!taskStatusDropdownOpen);
//     }
//     if (filterAttribute === "taskDate") {
//       setTaskDateDropdownOpen(!taskDateDropdownOpen);
//     }
//   };

//   const closeDropdown = () => {
//     setTagsDropdownOpen(false);
//   };

//   useEffect(() => {
//     // Attach a click event listener to the document
//     //  document.addEventListener("click", closeDropdown);

//     // Clean up the event listener when the component unmounts
//     return () => {
//       document.removeEventListener("click", closeDropdown);
//     };
//   }, []);

//   const handleDropdownClick = (e) => {
//     // Prevent the click on the dropdown itself from triggering the closeDropdown
//     e.stopPropagation();
//   };

//   const handleToggleClick = (event, filterAttribute) => {
//     event.stopPropagation();
//     toggleDropdown(filterAttribute);
//   };

//   const handlePresetFilterClick = (event, presetFilterQuery ) => {
//     event.stopPropagation();
//     setPresetFilterQuery(presetFilterQuery)
//     callback({ action: "filterApplied", presetFilterQuery: presetFilterQuery });
//   }


//   const handleChildCallback = (cb) => {
//     // FilterSidebarDropdown
//     console.log("CALLBACK@FILTERSIDEBAR", cb);

//     if (cb.filtersApplied) {
//       setFilterQuery(cb.filtersApplied)
//     }

//     if (cb.action === 'presetFilterApplied'){ 
//       callback({ action: "filterApplied", presetFilterQuery: cb.presetFilterQuery });
//     }

//     if (cb.action === "filterParameter") {
//       if (cb.attribute === 'tags') {
//         setTagsFiltered({ ...tagsFiltered, parameter: cb.parameter });
//         if (cb.parameter === "IS_EMPTY") {
//           setShowBooleanSelect(true);
//           setShowTagSelect(false);
//         } else {
//           setShowTagSelect(true);
//           setShowBooleanSelect(false);
//         }
//       }
//       else if (cb.attribute === 'communication_languages'){
//         setCommunicationLanguagesFiltered({ ...communicationLanguagesFiltered, parameter: cb.parameter });
//         setShowCommunicationLanguagesSelect(true)
//       }
//     }

//     // FilterMultiSelect
//     if (cb.action === "filterProperty") {
//       console.log(cb);
//       if (cb.attribute === 'tags') {
//         setTagsFiltered({
//         ...tagsFiltered,
//         attribute: cb.attribute,
//         properties: cb.properties,
//         })
//       }
//       else if (cb.attribute === 'communication_languages') {
//         setCommunicationLanguagesFiltered({
//           ...communicationLanguagesFiltered,
//           attribute: cb.attribute,
//           properties: cb.properties,
//           })
//       }
//     }

//     if (cb.action === "filterBoolean") {
//       setTagsFiltered({
//         ...tagsFiltered,
//         attribute: cb.attribute,
//         booleanValue: cb.value,
//       });
//     }
//     // console.log("FILTERED", filtered);
//     // callback({action: 'filter', filterQuery: filtered})
//   };


//   const mergedFilters = () => {
//     return {
//       tagsFiltered: tagsFiltered,
//       communicationLanguagesFiltered: communicationLanguagesFiltered
//     }
//   }



//   return (
//     // can get rid of div and leave aside
//     <div> 
//       <aside
//         id="sidebar"
//         className="px-2 fixed top-20 z-10 w-72 h-screen transition-transform -translate-x-full sm:translate-x-0 dark:border-gray-800"
//         // bg-white dark:bg-gray-900
//         aria-label="Sidebar"
//       >

// {/* IT */}
//           <Link 
//           // href={parentComponent === 'TALENT' ? 'talent' : 'jobs'} 
//           href={`?sectorId=${1}`}
//           onClick={()=>{setSectorIndustryId(1)}}>
//             <div className={`${sectorIndustryId === 1 && 'border-l-8 border-teal-400 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg`}>
//             {lang === 'fr' ? "Technologies de l'information" : 'Information Technology'} 
//             </div>
//           </Link>

//           <ul className={`${sectorIndustryId === 1 ? 'visible' : 'hidden'} ml-4`}>
//           <Link 
//             href={parentComponent === 'TALENT' ? 'talent?sectorId=1' : 'jobs'} 
//             onClick={()=>{setFilteredTagId(null)}}>
//       <li className={`${!filteredTagId && 'border-l-8 border-teal-400 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg`}>
//       {parentComponent === 'TALENT' && lang === 'fr' ? 'Tous les Talents' : parentComponent === 'TALENT' && lang === 'en' ? 'All Talent' : parentComponent === 'JOBS' && lang === 'fr' ? 'Tous les Emplois' : parentComponent === 'JOBS' && lang === 'en' ? 'All Jobs' : 'All / Tous'} 

//       </li>
//   </Link>
//   {console.log("TAWGS", tags)}
//   {tags && tags.filter(tag=>tag.tag_level === 1 && tag.tag_sector_industry.id === 1).sort((a, b) => {
//     console.log
//             // If both positions are null, keep their original order
//             if (a.tag_sidebar_position === null && b.tag_sidebar_position === null) return 0;
            
//             // Place tags with null position at the top
//             if (a.tag_sidebar_position === null) return -1;
//             if (b.tag_sidebar_position === null) return 1;
            
//             // Otherwise, sort by position in ascending order
//             return a.tag_sidebar_position - b.tag_sidebar_position;
//           }).map(tag => 
//     <Link key={tag.id} href={`?tagId=${tag.id}`} onClick={()=>{setFilteredTagId(tag.id)}}>
//       <li className={`${filteredTagId === tag.id && 'border-l-8 border-teal-400 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg`}>
//         {tag.tag_name}
//       </li>
//   </Link>
//     )}
//             </ul>


// {/* FINANCE */}
//           <Link 
//           // href={parentComponent === 'TALENT' ? 'talent' : 'jobs'} 
//           href={`?sectorId=${2}`}
//           onClick={()=>{setSectorIndustryId(2)}}>
//             <div className={`${sectorIndustryId === 2 && 'border-l-8 border-cyan-400 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg`}>
//             {lang === 'fr' ? "Finance" : 'Finance' } 
//             </div>
//           </Link>

//           <ul className={`${sectorIndustryId === 2 ? 'visible' : 'hidden'} ml-4`}>
//                 <Link href={parentComponent === 'TALENT' ? 'talent?sectorId=2' : 'jobs'} onClick={()=>{setFilteredTagId(null)}}>
//             <li className={`${!filteredTagId && 'border-l-8 border-cyan-400 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg`}>
//             {parentComponent === 'TALENT' && lang === 'fr' ? 'Tous les Talents' : parentComponent === 'TALENT' && lang === 'en' ? 'All Talent' : parentComponent === 'JOBS' && lang === 'fr' ? 'Tous les Emplois' : parentComponent === 'JOBS' && lang === 'en' ? 'All Jobs' : 'All / Tous'} 
  
//             </li>
//         </Link>
//         {tags && tags.filter(tag=>tag.tag_level === 1 && tag.tag_sector_industry_id === 2 )
//         .sort((a, b) => {
//           // If both positions are null, keep their original order
//           if (a.tag_sidebar_position === null && b.tag_sidebar_position === null) return 0;
          
//           // Place tags with null position at the top
//           if (a.tag_sidebar_position === null) return -1;
//           if (b.tag_sidebar_position === null) return 1;
          
//           // Otherwise, sort by position in ascending order
//           return a.tag_sidebar_position - b.tag_sidebar_position;
//         })
//         .map(tag => 
//          <Link key={tag.id} href={`?tagId=${tag.id}`} onClick={()=>{setFilteredTagId(tag.id)}}>
//             <li className={`${filteredTagId === tag.id && 'border-l-8 border-cyan-400 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg`}>
//               {tag.tag_name}
//             </li>
//         </Link>
//           )}
//             </ul>


//           {/* HEALTHCARE */}
//           <Link 
//           href={`?sectorId=${3}`}
//           // href={parentComponent === 'TALENT' ? 'talent' : 'jobs'} 
//           onClick={()=>{setSectorIndustryId(3)}}>
//             <div className={`${sectorIndustryId === 3 && 'border-l-8 border-sky-400 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg`}>
//             { lang === 'fr' ? "Santé" : 'Healthcare'} 
//             </div>
//           </Link>

//           <ul className={`${sectorIndustryId === 3 ? 'visible' : 'hidden'} ml-4`}>
//                 <Link href={parentComponent === 'TALENT' ? 'talent?sectorId=3' : 'jobs'} onClick={()=>{setFilteredTagId(null)}}>
//             <li className={`${!filteredTagId && 'border-l-8 border-sky-400 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg`}>
//             {parentComponent === 'TALENT' && lang === 'fr' ? 'Tous les Talents' : parentComponent === 'TALENT' && lang === 'en' ? 'All Talent' : parentComponent === 'JOBS' && lang === 'fr' ? 'Tous les Emplois' : parentComponent === 'JOBS' && lang === 'en' ? 'All Jobs' : 'All / Tous'} 
  
//             </li>
//         </Link>
//         {tags && tags.filter(tag=>tag.tag_level === 1 && tag.tag_sector_industry_id === 3 )
//         .sort((a, b) => {
//           // If both positions are null, keep their original order
//           if (a.tag_sidebar_position === null && b.tag_sidebar_position === null) return 0;
          
//           // Place tags with null position at the top
//           if (a.tag_sidebar_position === null) return -1;
//           if (b.tag_sidebar_position === null) return 1;
          
//           // Otherwise, sort by position in ascending order
//           return a.tag_sidebar_position - b.tag_sidebar_position;
//         })
//         .map(tag => 
//          <Link key={tag.id} href={`?tagId=${tag.id}`} onClick={()=>{setFilteredTagId(tag.id)}}>
//             <li className={`${filteredTagId === tag.id && 'border-l-8 border-sky-400 bg-gray-200 dark:bg-gray-900'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-900 dark:text-gray-300 text-sm font-bold duration-200 rounded-lg`}>
//               {tag.tag_name}
//             </li>
//         </Link>
//           )}
//             </ul>


            
//         <div className="px-4 pb-4 overflow-y-auto ">


    
//         <div>
//     {/* <div class="gp-container-title social-icons-bar">
//      <img src="../assets/icons/bell2.svg" className="social-icons" style={{width:"20px"}}/>
//      Create a Job Alert</div> */}
//     <br/>

//  {/* <JobAlertBox lang={lang}/> */}
  
//   </div>


//         </div>

//         {/* <div className="fixed bottom-6  ml-4 z-20 flex space-x-4 ml-14">
//           <IndigoButton
//             caption={"Apply Filter(s)"} // this applies customFilter
//             onClick={() => {
//               console.log("filterQuery", filterQuery)
//               callback({ action: "filtersApplied", filterQuery: filterQuery }); 
//             }}
//             fontSize={"xs"}
//           />
//           <GrayButton
//             caption={"Reset"}
//             fontSize={"xs"}
//             onClick={() => {
//               callback({ action: "filterReset" });
//               setFiltered(null);
//               setShowTagSelect(null);
//             }}
//           />
//         </div> */}
//       </aside>


//     </div>
//   );
// };

// export default Sidebar;